import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../../services/notification.service'; // NotificationService;
import { getCampaignPlatformIds } from '../../../services/campaign.service';
import {
  CampaignSuccessPlatformLink,
  buildCampaignSuccessPlatformLinks,
} from './campaign-success-modal.mapper';
import {
  CampaignLandingReadinessSource,
  LANDING_PAGE_PENDING_SHARE_LINKS_HINT,
  isCampaignLandingPageReady,
} from '../optional-setting/common-website-content.mapper';

@Component({
  selector: 'app-campaign-success-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './campaign-success-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './campaign-success-modal.component.scss',
})
export class CampaignSuccessModalComponent implements OnChanges {
  @Input() isOpen = false;
  @Input() campaignId: string | null = null;
  @Input() campaignData: ({ platform?: any } & CampaignLandingReadinessSource) | null = null;
  @Output() close = new EventEmitter<void>();

  platformLinks: CampaignSuccessPlatformLink[] = [];
  landingPageReady = false;
  /** Platforms exist but their links stay hidden until the landing page is created. */
  showLandingPagePendingHint = false;
  readonly landingPagePendingHint = LANDING_PAGE_PENDING_SHARE_LINKS_HINT;

  private messageService = inject(NotificationService);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] || changes['campaignId'] || changes['campaignData']) {
      this.landingPageReady = isCampaignLandingPageReady(this.campaignData);
      this.platformLinks = buildCampaignSuccessPlatformLinks(
        this.campaignId ?? '',
        this.campaignData?.platform,
        this.landingPageReady
      );
      this.showLandingPagePendingHint =
        !this.landingPageReady && getCampaignPlatformIds(this.campaignData?.platform).length > 0;
    }
  }

  onClose(): void {
    this.close.emit();
  }

  copyUrl(url: string): void {
    navigator.clipboard.writeText(url).then(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Copied',
        detail: 'Campaign URL copied to clipboard.',
        life: 2000,
      });
    });
  }
}
